import React, { Fragment } from 'react'

import WhatsApp from '../../../../assets/svgs/WhatsApp'

const InviteFooter = () => {
  const whatsappLink = () => {
    window.open('http://wa.me/554192727635')
  }

  return (
    <Fragment>
      <div className='invite-footer'>
        <div className='invite-footer_title'>Saiba Mais</div>
        <div className='invite-footer_content_left'>
          <div className='invite-footer_text'>Vem conversar com a gente que explicamos</div>
          <div className='invite-footer_text'>tudo para você via WhatsApp.</div>
          <div className='invite-footer_text'>Temos certezas que iremos encantar você!</div>
        </div>

        <button className='invite-footer_whatsapp_button' onClick={() => whatsappLink()}>
          Fale com a gente <WhatsApp />
        </button>

        <div className='invite-footer_content'>
          <b className='invite-footer_text'>Não quero fazer parte desta negociação</b>
          <p className='invite-footer_subtext'>
            Caso não opte por não participar desta negociação apenas ignore este convite.
          </p>
        </div>
      </div>
    </Fragment>
  )
}

export default InviteFooter
